import { ReportVisibilityService } from './../../base/services/report-visibility.service';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { GridBaseComponent } from '../../base/shared/grid-base/grid-base.component';
import { ClientService } from '../../base/services/client/client.service';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { SpinnerService } from '../../base/spinner/spinner.service';
import { DataManager } from '@syncfusion/ej2-data';
import { AvpCustomAdaptor } from '../../base/shared/syncfusion/avp-custom-adaptor';
import { ReportsService } from './reports.service';
import { GridConstantsFactory } from '../../base/shared/syncfusion/grid-constants-factory';
import { Router } from '@angular/router';
import { ClientDTO, ReportFileType, ReportType, SavedReportDTO, SavedReportFileDTO } from 'src/app/base/models/models.swagger.generated';
import {
  automaticParkingReportRoute,
  deviceStatusRoute,
  falseRecordingsRoute,
  parkerExtractRoute,
  parkerRegistrationsRoute,
  parkerTurnoverRoute,
  paymentReportRoute,
  tagsPerParkerRoute,
  userExtractRoute,
} from '../../core/routing/route-names';
import { EnumTranslationService } from '../../base/services/enum-translation.service';
import { MenuEventArgs, DropDownButtonModule } from '@syncfusion/ej2-angular-splitbuttons';
import { AuthService } from '../../base/services/auth.service';
import { ReportsFormComponent } from './reports-form/reports-form.component';
import { ToolbarModule } from '@syncfusion/ej2-angular-navigations';
import { GridModule } from '@syncfusion/ej2-angular-grids';
import { ClientAutocompleteComponent } from '../../base/shared/client-autocomplete/client-autocomplete.component';
import { NgIf } from '@angular/common';
import { TitleBarComponent } from '../../base/shared/title-bar/title-bar.component';
import { DownloadLinkUtil } from './download-link.util';

@Component({
    selector: 'app-reports',
    templateUrl: './reports.component.html',
    styleUrls: ['./reports.component.scss'],
    imports: [
        TitleBarComponent,
        NgIf,
        ClientAutocompleteComponent,
        GridModule,
        ToolbarModule,
        DropDownButtonModule,
        ReportsFormComponent,
        TranslateModule,
    ]
})
export class ReportsComponent extends GridBaseComponent implements OnInit, AfterViewInit {

  @ViewChild(ClientAutocompleteComponent)
  public clientAutocomplete: ClientAutocompleteComponent;

  public typeFilter = GridConstantsFactory.createCheckBoxFilter();

  public ReportType = ReportType;
  public enumSelectionData = this.enumTranslationService.translateNumericEnum(ReportType, 'i18n.shared.reportTypes.', [ReportType.ParkingPermit])
    .filter(data => this.canUserSeeReport(data.value));

  constructor(clientService: ClientService,
    public translate: TranslateService,
    private authService: AuthService,
    private router: Router,
    private enumTranslationService: EnumTranslationService,
    private reportsService: ReportsService,
    private spinnerService: SpinnerService,
    private reportVisibilityService: ReportVisibilityService) {
    super(clientService, translate, reportsService);
  }

  public override get selectedClient(): ClientDTO {
    return this.clientService.selectedClient;
  }

  public override set selectedClient(value: ClientDTO) {
    if (this.clientService.selectedClient != value) {
      this.clientService.selectedClient = value;
      this.onClientSelected(value);
    }
  }

  ngOnInit(): void {
    this.data = new DataManager({
      adaptor: new AvpCustomAdaptor(this.reportsService, this.spinnerService),
    });
    this.editSettings.allowEditing = false;
  }

  ngAfterViewInit(): void {
    if (!this.selectedClient) {
      this.focusClientAutocomplete();
    }
  }

  public onBeforeItemRender(args: MenuEventArgs) {
    args.element.innerHTML = this.translateService.instant(args.item.text);
  }

  public downloadFile(reportId: number): void {
    this.reportsService.getSavedReportFile(reportId)
      .subscribe(savedReportFileDTO => {
        const link = DownloadLinkUtil.createInvisibleDownloadLink(savedReportFileDTO);
        link.click();
      });
  }

  public get allowClientSelection(): boolean {
    return this.authService.isUserAdminOrClientAdmin() || this.authService.hasUserClientAssigned();
  }

  public navigateToReport(event): void {
    const reportType = event.item.value;
    let routeToNavigate = null;
    switch (reportType) {
      case ReportType.TagsPerParker: {
        routeToNavigate = tagsPerParkerRoute;
        break;
      }
      case ReportType.ParkerRegistrations: {
        routeToNavigate = parkerRegistrationsRoute;
        break;
      }
      case ReportType.FalseRecordings: {
        routeToNavigate = falseRecordingsRoute;
        break;
      }
      case ReportType.ParkerTurnover: {
        routeToNavigate = parkerTurnoverRoute;
        break;
      }
      case ReportType.ParkerExtract: {
        routeToNavigate = parkerExtractRoute;
        break;
      }
      // case ReportType.IAMReportWithTagInformation: {
      //   routeToNavigate = iamReportWithTagInformationRoute;
      //   break;
      // }
      case ReportType.DeviceStatus: {
        routeToNavigate = deviceStatusRoute;
        break;
      }
      // case ReportType.ParkerPerTariff: {
      //   routeToNavigate = parkerPerTariffRoute;
      //   break;
      // }
      // case ReportType.ParkingUtilization: {
      //   routeToNavigate = parkerUtilizationRoute;
      //   break;
      // }
      case ReportType.AutomaticParking: {
        routeToNavigate = automaticParkingReportRoute;
        break;
      }
      case ReportType.Payment: {
        routeToNavigate = paymentReportRoute;
        break;
      }
      case ReportType.UserExtract: {
        routeToNavigate = userExtractRoute;
        break;
      }
      default: {
        return;
      }
    }

    this.router.navigate([routeToNavigate]);
  }

  public getReportTypeString(report: SavedReportDTO): string {
    return 'i18n.shared.reportTypes.' + ReportType[report.reportType];
  }

  protected getEditDialogTitleParams(rowData: any): any {
  }

  protected initializeEditForm(data: any): void {
  }

  private canUserSeeReport(reportType: any): boolean {
    return this.reportVisibilityService.canUserSeeReport(reportType);
  }

  private focusClientAutocomplete(): void {
    if (this.clientAutocomplete) {
      this.clientAutocomplete.focus();
    }
  }
}
